var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { colors } from '../styles/MuiTheme';
import { useTheme } from '@mui/material';
export var GitHubFlavoredMarkdown = function (_a) {
    var gfmd = _a.gfmd;
    var theme = useTheme();
    return (_jsx("span", __assign({ style: {
            color: colors.rsLightestBrown,
            marginLeft: '1em',
            display: 'inline-block',
            fontSize: theme.typography.h6.fontSize,
        } }, { children: _jsx(Markdown, __assign({ remarkPlugins: [remarkGfm] }, { children: gfmd })) })));
};
